import React from 'react';
import PropTypes from 'prop-types';

const FormGroupLabel = ({ value, className = '' }) => (
  <h4 className={className}>{value}</h4>
);

FormGroupLabel.propTypes = {
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default FormGroupLabel;
